import { motion } from "motion/react";
import { Eyebrow } from "../components/Buttons";
import { Stagger, Reveal } from "../components/Reveal";
import { EASE } from "../motion";
import { HOURS } from "../config";

const day = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

// Monday = 0 … Sunday = 6, so we can highlight "today".
const todayIdx = (new Date().getDay() + 6) % 7;

export default function Hours() {
  return (
    <section className="hours section--blue">
      <div className="container">
        <Reveal className="hours__head">
          <Eyebrow tone="on-blue">OPENING HOURS</Eyebrow>
          <span className="hours__addr">5A Market Lane, Manly</span>
        </Reveal>
        <Stagger className="hours__grid" gap={0.06}>
          {HOURS.map(([d, h, late], i) => (
            <motion.div key={d} variants={day}
              className={"hours__day" + (late ? " is-late" : "") + (i === todayIdx ? " is-today" : "")}>
              <span className="hours__d">{d}{i === todayIdx && <em className="hours__today">Today</em>}</span>
              <span className="hours__h">{h}</span>
              {late && (
                <motion.span className="hours__badge"
                  animate={{ scale: [1, 1.08, 1] }} transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}>
                  LATE NIGHT
                </motion.span>
              )}
            </motion.div>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
